export default {
  isochronesDetails: {
    polygons: 'Poligoane',
    center: 'Centru',
    reachCenters: 'Centrele Reach',
    toggleVisibility: 'Comutați vizibilitatea',
    opacity: 'Opacitate',
  }
}
